export var isIE = function isIE() {
  if (typeof window !== 'undefined') {
    var userAgent = window.navigator.userAgent;
    return userAgent.indexOf('Trident/') > 0;
  } // Returning false if window is undefined


  return false;
};